import { render, staticRenderFns } from "./OptionCheckbox.vue?vue&type=template&id=d5a54f4e&"
import script from "./OptionCheckbox.vue?vue&type=script&lang=ts&"
export * from "./OptionCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports